
















































































































































































































































import { OperationModalVueSNB } from "@/extensions/history/OperationModalVueSNB";
import { Component } from "vue-property-decorator";
import FsTemplateDialog from "@/components/templates/FsTemplateDialog.vue";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: { FsTemplateDialog, BackLink }
})
export default class OperationModal extends OperationModalVueSNB {
  detailsVisible: boolean = false;
  documentsVisible: boolean = false;

  toggleDetails() {
    this.detailsVisible = !this.detailsVisible;
  }

  toggleDocuments() {
    this.documentsVisible = !this.documentsVisible;
  }
  sumValue(sum: any, currency: string, part: number): string {
    const val: string = this.$options.filters.sum(sum, true, currency);
    return part === 1 ? `${val.toString().substr(0, val.toString().indexOf(','))}` : 
      `${val.toString().substr(val.toString().indexOf(','), 1)} ${val.toString().substring(val.toString().indexOf(',')+1)}`;
  }

  getOperationModalTitle(): string {
    if (this.details && this.details.RequestData && this.details.RequestData.RequestStateRem && this.details.RequestData.RequestStateRem.length)
      return this.details.RequestData.RequestStateRem;
    return this.operationData.Category === 'Справки' || this.operationData.Category === 'Кредиты' ? 
      this.stringRequestStateRefs(this.operationData.RequestState, null) : 
      this.stringRequestState(this.operationData.RequestState, null);
  }
}
